export default async (trainingId: number): Promise<void> => {
  // eslint-disable-next-line no-console
  console.log(`video Assistido ${trainingId}`);
};
